import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { initBrazeAfterEngagement } from '../../command/braze';

// Batches multiple requestBannersRefresh calls into one,
// collecting all placement names within a short window.
const pendingPlacements = new Set();
let refreshTimer = null;

const scheduleBannerRefresh = (bannerName) => {
    pendingPlacements.add(bannerName);
    if (refreshTimer) return;
    refreshTimer = setTimeout(() => {
        const braze = window.braze;
        if (braze && typeof braze.requestBannersRefresh === 'function') {
            braze.requestBannersRefresh([...pendingPlacements]);
        }
        pendingPlacements.clear();
        refreshTimer = null;
    }, 100);
};

const BrazeBanner = ({ bannerName }) => {
    const containerRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        initBrazeAfterEngagement(() => {
            const braze = window.braze;

            braze.subscribeToBannersUpdates(() => {
                const banner = braze.getBanner(bannerName);
                if (!banner || banner.isControl) {
                    setVisible(false);
                    return;
                }

                setVisible(true);

                if (containerRef.current) {
                    braze.insertBanner(banner, containerRef.current);
                }
            });

            scheduleBannerRefresh(bannerName);
        });
    }, [bannerName]);

    return (
        <section
            className="content__section padding-top--6 margin-bottom--3"
            style={{ display: visible ? '' : 'none' }}
        >
            <div className="grid-container">
                <div ref={containerRef}></div>
            </div>
        </section>
    );
};

BrazeBanner.propTypes = {
    bannerName: PropTypes.string.isRequired,
};

export default BrazeBanner;